export const closeOtherContent = (contentOpened = {}, key) => {
  const result = {}
  Object.keys(contentOpened).forEach(contentKey => {
    result[contentKey] = false
  })

  // leave parent tree open for further modifications in the form
  const path = key.split('.')
  let parentPath = path.slice(0, 2).join('.') // parent.interestedParty[0]
  result[parentPath] = true
  path.slice(2).forEach(parent => {
    parentPath = `${parentPath}.${parent}`
    result[parentPath] = true
  })

  return result
}
